import { ActionType, createAsyncAction } from "typesafe-actions";

import { GuideUserStatus } from "@mapmycustomers/shared/types/entity";

export const updateGuideStatus = createAsyncAction(
  "@onboarding/updateGuideStatus/request",
  "@onboarding/updateGuideStatus/success",
  "@onboarding/updateGuideStatus/failure"
)<GuideUserStatus, void, void>();

export const refreshGuidesStatus = createAsyncAction(
  "@onboarding/refreshGuidesStatus/request",
  "@onboarding/refreshGuidesStatus/success",
  "@onboarding/refreshGuidesStatus/failure"
)<
  void,
  {
    guidesStatus: GuideUserStatus[];
  },
  void
>();

export type Actions = ActionType<typeof refreshGuidesStatus | typeof updateGuideStatus>;
